<div class="card d-flex">
  <div class="card-body">
    <!-- Need 2 divs because the loader is sensitive -->
    <div class="loader-container" *ngIf="isLoading">
      <div class="loader-container">
        <span *nfLoader="isLoading || false"></span>
      </div>
    </div>
    <div>
      <h3>
        <i *ngIf="icon" class="mdi {{ iconClass }}" [ngClass]="icon"></i>
        {{ header }}
      </h3>
      <div class="text-muted">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
